import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
export var CustomCssStylesheet = function (_a) {
    var css = _a.css;
    return css ? (_jsx("style", { className: "seq-results-portal-custom-css", "data-seq-results-custom-css": "active", children: css })) : null;
};
